export const fixPathFromWindowsToLinux = (path: string) => path?.replace(/\\/gi, "/").trim();
